import RESTWorkflowService from 'src/services/RESTWorkflowService';

const restWorkflowService = new RESTWorkflowService();

export const SET_ALLDISPATCHWORKFLOWS = '@types/set-alldispatchworkflows';

export function setAllDispatchWorkflows(existingReduxWorkflows) {
  if (existingReduxWorkflows) {
    return (dispatch) => {
      dispatch({
        type: SET_ALLDISPATCHWORKFLOWS,
        payload: {
          allDispatchWorkflows: existingReduxWorkflows,
        }
      });
    };
  }
  const request = restWorkflowService.getWorkflows();
  return (dispatch) => {
    request.then((response) => {
      dispatch({
        type: SET_ALLDISPATCHWORKFLOWS,
        payload: response
      });
    });
  };
}
